import Icon from '../components/Icon.vue'

Icon.register({
  meteor: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M491.2 0.7C452.5 12.3 379.4 35 303.5 62 301.4 55 299.5 48.5 297.9 43.4 294.9 33.7 284 29.2 275 33.9 232.6 56 122.2 116.5 60.6 176.4 59.5 177.4 58.1 178.4 57.1 179.4 19 217.4 0 267.3 0 317.2 0 367 19 416.9 57 455 95 493 144.9 512.1 194.8 512 244.7 512 294.6 493 332.7 454.9 333.7 453.9 334.7 452.5 335.7 451.4 395.5 389.8 456.1 279.3 478.2 237 482.9 228 478.4 217.1 468.7 214.1 463.5 212.5 457.1 210.6 450.1 208.5 477.1 132.5 499.8 59.5 511.4 20.8 515 8.4 503.6-3 491.2 0.7zM192 448C121.3 448 64 390.7 64 320S121.3 192 192 192 320 249.3 320 320 262.7 448 192 448zM160 256C142.3 256 128 270.3 128 288S142.3 320 160 320 192 305.7 192 288 177.7 256 160 256zM208 352C199.2 352 192 359.2 192 368S199.2 384 208 384 224 376.8 224 368 216.8 352 208 352z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/meteor.js
// module id = O5Tr
// module chunks = 144